import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportOverviewComponent } from './components/report-overview/report-overview.component';
import * as fromContainers from './containers';
import { ReportCustomerPositionComponent } from './components/report-customer-position/report-customer-position.component';
import { ReportNfsaleComponent } from './components/report-nfsale/report-nfsale.component';
import { ReportReceiptComponent } from './components/report-receipt/report-receipt.component';

const routes: Routes = [
  { path: '', component: fromContainers.ConferenceReportComponent },
  { path: 'orders', component: fromContainers.OrdersReportsComponent },
  { path: 'table', component: fromContainers.TableReportComponent },
  { path: 'stock', component: fromContainers.StockReportComponent },
  { path: 'position', component: ReportCustomerPositionComponent },
  { path: 'nfsale', component: ReportNfsaleComponent },
  { path: 'integration', component: fromContainers.IntegrationReportComponent },
  { path: 'picking', component: fromContainers.PickingReportComponent },
  { path: 'receipt', component: ReportReceiptComponent },
  { path: 'overview', component: ReportOverviewComponent }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
